<template>
  <el-dialog
    v-if="dialogVisible"
    class="create-node-dialog common-dialog"
    :close-on-click-modal="false"
    :visible.sync="dialogVisible"
    :before-close="handleCancel"
    :title="title"
  >
    <el-form
      ref="dataForm"
      :model="dataForm"
      :label-position="position"
      :rules="editRule"
      :label-width="`${adaptationVars.formLabelWidth}px`"
    >
      <el-form-item label="选择组织" prop="orgId">
        <el-select
          ref="mySelect"
          v-model="dataForm.orgId"
          placeholder="请选择"
          @change="handleSelect"
        >
          <el-option
            v-for="item in orgOptions"
            :key="item.OrgId"
            :label="item.OrgName"
            :value="item.OrgId"
          >
          </el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="选择节点" prop="nodeId">
        <el-select v-model="dataForm.nodeId" placeholder="请选择">
          <el-option
            v-for="item in nodeList"
            :key="item.NodeId"
            :label="item.NodeName"
            :value="item.NodeId"
          >
          </el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="选择用户" prop="userId">
        <el-select v-model="dataForm.userId" placeholder="请选择">
          <el-option
            v-for="item in userOptions"
            :key="item.UserId"
            :label="item.UserName"
            :value="item.UserId"
          >
          </el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="扩容节点IP地址" prop="serverIP">
        <el-input v-model="dataForm.serverIP"></el-input>
      </el-form-item>

      <el-form-item label="IP端口" prop="serverPort">
        <el-input v-model="dataForm.serverPort"></el-input>
      </el-form-item>

      <el-form-item label="p2p端口" prop="sp2pPort">
        <el-input v-model="dataForm.sp2pPort"></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="handleCancel">取消</el-button>
      <el-button type="primary" :disabled="disabled" @click="handleCreateOffChain()"
        >确定</el-button
      >
    </div>
  </el-dialog>
</template>

<script>
import adaptation from '@/mixins/adaptation'
export default {
  name: 'CreateNode',
  mixins: [adaptation],
  adaptationVarsDefine: {
    formLabelWidth: 120
  },
  data() {
    return {
      disabled: false,
      dialogVisible: false,
      orgOptions: [], //组织
      userOptions: [], //用户列表
      nodeList: [], //节点列表
      orgId: '',
      title: '新建扩容节点',
      position: 'right',
      paramList: [{ key: '', value: '' }],
      dataForm: {
        nodeId: '',
        userId: null,
        serverIP: '',
        serverPort: null,
        sp2pPort: null,
        chainId: ''
      },
      editRule: {
        nodeId: [{ required: true, message: '请输入', trigger: 'blur' }],
        userId: [
          { required: true, message: '请输入', trigger: 'blur' },
          { pattern: /^[1-9]\d*$/, message: '请输入正整数', trigger: 'blur' }
        ],
        serverIP: [{ required: true, message: '请输入', trigger: 'blur' }],
        serverPort: [
          { required: true, message: '请输入', trigger: 'blur' },
          { pattern: /^[1-9]\d*$/, message: '请输入正整数', trigger: 'blur' }
        ],
        sp2pPort: [
          { required: true, message: '请输入', trigger: 'blur' },
          { pattern: /^[1-9]\d*$/, message: '请输入正整数', trigger: 'blur' }
        ]
      },
      adaptationVars: {
        formLabelWidth: 120
      }
    }
  },
  mounted() {
    this.getOrgOption()
    // 获取当前选中值
  },
  methods: {
    //创建扩容节点
    handleCreateOffChain() {
      this.$refs.dataForm.validate(async valid => {
        if (valid) {
          this.disabled = true
          //获取form数据
          this.dataForm.chainId = this.$route.query.chainId
          this.dataForm.userId = Number(this.dataForm.userId)
          this.dataForm.serverPort = Number(this.dataForm.serverPort)
          this.dataForm.sp2pPort = Number(this.dataForm.sp2pPort)
          this.$apis.chain
            .createOffChain(this.dataForm)
            .then(res => {
              if (res) {
                this.$message.success('新建扩容节点成功')
                this.$emit('update:list')
                this.$emit('createNodeSuccess', res.data.offchainId)
                this.handleCancel()
              } else {
                this.$message.error(err)
                this.disabled = false
              }
            })
            .catch(err => {
              // this.$message.error(err)
              this.disabled = false
            })
        } else {
          this.$message.warning('请完善信息')
          this.disabled = false
          return
        }
      })
    },
    //获取组织
    getOrgOption() {
      let param = {
        offset: 0,
        limit: 50,
        chainId: this.$route.query.chainId
      }
      this.$apis.chain.getChainOrgList(param).then(res => {
        if (res.data.items) {
          this.orgOptions = res.data.items
          this.orgId = this.orgOptions[0]['OrgId']
        }
      })
    },
    handleSelect(val) {
      this.orgId = val
      this.handleGetUserList(this.orgId)
      this.handleGetNodeList(this.orgId)
    },
    //获取用户列表
    handleGetUserList(OrgId) {
      this.$apis.certificate.getUserListByOrg({ OrgId }).then(res => {
        if (res.data && res.data.items) {
          this.userOptions = res.data.items
        }
      })
    },
    //获取节点列表
    handleGetNodeList(orgId) {
      let param = {
        offset: 0,
        limit: 1000,
        orgId: orgId,
        chainId: this.$route.query.chainId
      }

      this.$apis.chain.queryChainOrgNode(param).then(res => {
        if (res) {
          this.nodeList = res.data.items
        }
      })
    },
    handleCancel() {
      this.dialogVisible = false
      this.disabled = false
      this.$refs.dataForm.resetFields()
    },
    handleOpen(chainId) {
      this.dataForm = {
        nodeId: '',
        userId: null,
        serverIP: '',
        serverPort: null,
        sp2pPort: null,
        chainId: ''
      }
      this.dialogVisible = true
    },
    formatTime(row) {
      return this.$utils.dateFormat('YYYY-mm-dd HH:MM', row)
    },
    formatType(row) {
      return row === 0 ? '共识节点' : '普通节点'
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/styles/variables/theme';
@import '@/styles/variables/adaptation';

@include theme('create-node-dialog', (), ());
.create-node-dialog.common-dialog {
  @include adaptation(());
  /deep/ .el-dialog {
    width: var(--common-dialog-medium-width);
  }

  .el-form {
    margin-right: var(--common-dialog-form-margin-right);
  }

  .el-select {
    width: 100%;
  }
}
</style>
